// import Worker from '@/lib/gooroomee/mediapipe/selfie-segmentation/grm-selfieSegmentation-worker.worker';
import Worker from 'worker-loader!./grm-selfieSegmentationWorker-runner';


export default class GrmSelfieSegmentationWorker {
    options={};
    _msgResponseData=  {}
    _workerDependencies = {};
    _props = {
        monitor: []
    }

    constructor(options) {
        Object.assign(this.options, options);
    }

    async init () {
        const worker = this.worker = new Worker();

        return new Promise((resolve, reject) => {
            const onmessage = async e => {
                const msg = event.data;
                // console.log('# on w->m msg:', event);

                if(msg.type === 'res'){
                    const req = this._msgResponseData[msg.msgId];
                    delete this._msgResponseData[msg.msgId];
                    if(!req){
                        return;
                    }
                    if(msg.data && typeof msg.data === 'object'){
                        for(let key in msg.data){
                            let value = msg.data[key];
                            if(typeof value !== 'object') continue;
                            if(!value.__function) continue;
                            try{
                                eval('msg.data[key] = ' + value.srcStr);
                            }catch(e){
                                console.error(e);
                            }
                        }
                    }

                    if(msg.error){
                        req.reject(msg.error);
                    }else{
                        req.resolve(msg.data);
                    }
                }
            };

            worker.onmessage = async e => {
                if(e.data?.type !== 'loaded'){
                    console.log('# worker init msg:', e.data);
                    return;
                }
                if(e.data.dependencies){
                    this._workerDependencies = e.data.dependencies;
                }
                try{
                    worker.loaded = true;
                    worker.onmessage = onmessage
                    await this._sendApi('init', this.options);
                    resolve();
                }catch(e){
                    reject(e);
                }
            }
        });
    } // end of init

    async _sendApi (api, data, transfer) {
        const {worker} = this;

        if(!this.__id__){
            this.__id__ = 'grmnsfw-'+Date.now();
        }
        let msgId = this.__id__;
        if(crypto?.randomUUID){
            msgId += '@' + crypto.randomUUID();
        }else{
            msgId += '@' + performance.now();
        }
        const msg = {
            type: 'req',
            msgId,
            api,
            data
        };
        return new Promise((resolve, reject) => {
            this._msgResponseData[msg.msgId] = {
                msg,
                resolve, reject
            };
            // console.log('# send msg m->w msg:', msg);
            worker.postMessage(msg, transfer);
        })
    }

    async _sendCoreApi (api, args, transfer) {
        if(args === undefined || args === null){
            args = [];
        }else if(!Array.isArray(args)){
            args = [args];
        }
        return this._sendApi('api', {
            api,
            args: [...args],
            transfer
        })
    }

    async detectForPerson (image) {
        let imgData = image;
        if(imgData instanceof ImageBitmap === false){
            imgData = await createImageBitmap(image);
        }

        const result = await this._sendCoreApi('detectForPerson', [
                imgData
            ],
            [imgData]
        );
        return result;
    }

    async detectMonitorForVideo ({
                                     video,
                                     detectIntervalMs,
                                     callback
                                 }) {
        const {monitor} = this._props;
        const id = 'smt-'+performance.now();

        const RunData = {
            id,
            video,
            run: true,
            destroy: false,
            timer: null,
            lastVideoTime: -1,
            detectCount: 0,
            callbackData: {
                changeDetectIntervalMs: (ms) => {
                    if(detectIntervalMs !== ms && video.srcObject){
                        const track = video.srcObject.getVideoTracks()[0];
                        if(track){
                            const frameRate = track.getSettings().frameRate;
                            ms = Math.max(ms, 1000 / frameRate);
                        }
                    }

                    detectIntervalMs = ms;
                    if(RunData.run){
                        if(RunData.runTimer){
                            clearTimeout(RunData.runTimer);
                        }
                        RunData.runTimer = setTimeout(() => {
                            delete RunData.runTimer;
                            globalThis.requestAnimationFrame(segmentVideo);
                        }, detectIntervalMs || 1000);
                    }
                },
                pause: () => {
                    if(!RunData.run) return;
                    clearTimeout(RunData.runTimer);
                    RunData.run = false;
                    video.pause();
                },
                resume: () => {
                    if(RunData.destroy){
                        throw 'destroyed';
                    }
                    if(RunData.run) return;
                    RunData.run = true;
                    RunData.lastVideoTime = video.currentTime;
                    segmentVideo();
                },
                destroy: function(){
                    this.pause();
                    let idx = monitor.findIndex(m => m === RunData);
                    if(idx > -1){
                        monitor.splice(idx, 1);
                    }
                    RunData.destroy = true;
                },
                isDestroyed: function(){
                    return RunData.destroy;
                }
            }
        };

        const segmentVideo = async () => {
            if(!RunData.run){
                return;
            }
            let paused = video.paused;
            if (RunData.lastVideoTime !== video.currentTime) {
                if (RunData.lastVideoTime !== video.currentTime) {
                    RunData.lastVideoTime = video.currentTime;
                }
                const result = await this.detectForPerson(video);
                Object.assign(RunData.callbackData, {
                    data: result,
                });
                callback(RunData.callbackData);
            }else if(video.currentTime === 0){
                if(
                    isNaN(video.duration)
                    || !video.srcObject
                    || !video.src
                ){
                    paused = true;
                }
            }

            if(paused){
                return;
            }
            RunData.callbackData.changeDetectIntervalMs(detectIntervalMs || 1000)
        }

        if(video.paused){
            video.addEventListener('playing', e => {
                segmentVideo();
            });
            video.play().catch(e => {
                console.error(e);
            })
        }else{
            segmentVideo();
        }
        monitor.push(RunData);
    }
}